module.exports = __webpack_public_path__ + "images/bug_yellow_large_d1d4da9c12a423f0d70ab2ef61d5d368.png";